import { useNgSession } from "@/shared/ng/ng-session";
import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";

export const xPlayerIdHeaderInterceptor = (config: InternalAxiosRequestConfig) => {
    const { isLoggedIn, session } = useNgSession();
    if (isLoggedIn.value && session.value?.PlayerID) {
        config.headers.set("X-PLAYER-ID", session.value.PlayerID);
    }
    return config;
};

export const addXPlayerIdHeaderInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(xPlayerIdHeaderInterceptor);
};
